<template>
  <div class="header">
    <!-- 顶部搜索框 -->
    <div class="zhiboImg">
      <a @click="routerSwitch">
        <img src="../assets/img/back.png" />
      </a>
      <!-- <router-link to="/" v-else>
        <img src="../assets/img/back.png" />
      </router-link> -->
    </div>

    <label @click="search" class="searchLabel">
      <mt-search cancel-text="取消" placeholder="请输入直播名称"></mt-search>
    </label>
    <div class="menuContext">
      <img @click="showMenu" src="../assets/img/menu.png" />
      <div class="menu" :style="{ display: menuShow }">
        <mt-cell title="首页" to="/"></mt-cell>
        <mt-cell title="直播" to="/live"></mt-cell>
        <mt-cell title="个人中心" to="personal"></mt-cell>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['pages', 'liveId'],
  data() {
    return {
      menuShow: 'none',
      href: '',
      slectedValue: ''
    }
  },

  methods: {
    routerSwitch() {
      // debugger
      if (!this.pages && this.liveId) {
        // this.$router.push({
        //   path: '/details',
        //   query: {
        //     liveId: this.liveId
        //   }
        // })
        const routeData = this.$router.resolve({
          path: '/details',
          query: { liveId: this.liveId }
        })
        window.open(routeData.href, '_blank')
      } else if (this.pages) {
        this.$router.go(-1)
      } else {
        this.$router.push('/')
      }
    },
    // 跳转到搜索页面
    search() {
      // this.$router.push('/search')
      const routeData = this.$router.resolve({
        path: '/search'
      })
      window.open(routeData.href, '_blank')
    },
    // 控制菜单显示
    showMenu() {
      if (this.menuShow === 'none') {
        this.menuShow = 'block'
      } else {
        this.menuShow = 'none'
      }
    }
  },
  mounted() {
    this.slectedValue = localStorage.getItem('slectedValue')
  }
}
</script>
<style lang="scss" scoped>
.header {
  background-color: #fff;
  padding: 1rem;
  display: flex;
  align-items: center;
  // align-content: center;
  justify-content: space-between;
  z-index: 100;
  a {
    color: #333;
    display: block;
    font-size: 12px;
  }
}
.zhiboImg {
  text-align: center;
  width: 5%;
  img {
    width: 24px;
  }
}
.searchLabel {
  width: 80%;
  margin-top: 5px;
}
/deep/ .mint-search {
  box-sizing: border-box;
  height: 100%;
}
/deep/ .mint-searchbar {
  background-color: #fff;
  width: 100%;
  padding: 0;
}
/deep/ .mint-searchbar-inner {
  background-color: #eee;
  padding: 0.5rem 2rem;
  border-radius: 4rem;
  font-size: 14px;
  height: 35px;
}
/deep/ .mint-searchbar-inner .mintui-search {
  font-size: 14px;
}
/deep/ .mint-searchbar-core {
  background-color: #eee;
  padding-left: 1rem;
}
.menuContext {
  width: 10%;
  text-align: center;
  img {
    width: 90%;
  }
  .menu {
    position: absolute;
    top: 6rem;
    right: 1rem;
    width: 10rem;
    z-index: 1000000;
    border: 1px solid #eee;
  }
}
/deep/ .mint-cell-title {
  color: #f5a323;
}
</style>
